import { z } from 'zod'
import { getCollections } from './getCollections'

export const baseOptionSchema = z.object({
  key: z.number(),
  value: z.string(),
  iconSrc: z.string().optional(),
})

export const changePaymentSchema = (collection: string[]) =>
  z
    .object({
      financialSourceId: baseOptionSchema.nullable(),
      reasonId: baseOptionSchema.nullable(),
      territory: z
        .string()
        .nullable()
        .refine((arg) => collection.includes(arg ?? '')),
      locality: z.string().nullable(),
      addressType: z.string().nullable(),
      address: z.string().nullable(),
      house: z.string().nullable(),
      building: z.string().nullable(),
      apartment: z.string().nullable(),
      district: z.string().nullable(),
    })
    .refine(
      (data) => {
        const { districtOptions } = getCollections(
          data.territory,
          data.district,
          data.locality,
          -1
        )
        return districtOptions.includes(data.district)
      },
      {
        message: 'invalid',
        path: ['district'],
      }
    )
    .refine(
      (data) => {
        const { localitiesOptions } = getCollections(
          data.territory,
          data.district,
          data.locality,
          -1
        )
        return localitiesOptions.includes(data.locality)
      },
      {
        message: 'invalid',
        path: ['locality'],
      }
    )

export const changeInfoSchema = (requredComment: boolean) =>
  z
    .object({
      name: z.string().nullable(),
      surname: z.string().nullable(),
      patronymic: z.string().nullable(),
      phone: z.string().nullable(),
      territory: z.string().nullable(),
      locality: z
        .string()
        .nullable()
        .refine((val) => !!val),
      addressType: z.string().nullable(),
      address: z.string().nullable(),
      house: z.string().nullable(),
      building: z.string().nullable(),
      apartment: z.string().nullable(),
      district: z
        .string()
        .nullable()
        .refine((val) => !!val),
      preferentialCategory: z.string().nullable(),
      categories: z.array(z.boolean()),
      updateComment: z
        .string()
        .nullable()
        .refine((arg) => (requredComment ? !!arg?.length : true)),
    })
    .refine(
      (data) => {
        const { districtOptions } = getCollections(
          data.territory,
          data.district,
          data.locality,
          -1
        )
        return districtOptions.includes(data.district)
      },
      {
        message: 'invalid',
        path: ['district'],
      }
    )
    .refine(
      (data) => {
        const { localitiesOptions } = getCollections(
          data.territory,
          data.district,
          data.locality,
          -1
        )
        return localitiesOptions.includes(data.locality)
      },
      {
        message: 'invalid',
        path: ['locality'],
      }
    )

export const getChangeDetailsSchema = (requredComment: boolean) =>
  z.object({
    senderId: baseOptionSchema.nullable(),
    reasonId: baseOptionSchema.nullable(),
    updateComment: z
      .string()
      .nullable()
      .refine((arg) => (requredComment ? !!arg?.length : true)),
  })

export type BaseOptionType = z.infer<typeof baseOptionSchema>
export type ChangePaymentFormType = z.infer<
  ReturnType<typeof changePaymentSchema>
>
export type ChangeDetailsFormType = z.infer<
  ReturnType<typeof getChangeDetailsSchema>
>

export type ChangeInfoFormType = z.infer<ReturnType<typeof changeInfoSchema>>
